// @flow

import React from "react";

import { MessageCard, MessageNotchContainer } from "./styles";
import Icon from "src/icons";

type Props = {
  children: any,
  first: boolean,
  isCurrentUser?: boolean,
  maxWidth?: boolean,
  isChecklist?: boolean,
  singleLine?: boolean
};

const MessageNotch = ({
  children,
  first,
  isCurrentUser = false,
  maxWidth = false,
  isChecklist = false,
  singleLine = false,
  ...restProps
}: Props) => (
  <MessageCard
    first={first}
    isCurrentUser={isCurrentUser}
    maxWidth={maxWidth}
    isChecklist={isChecklist}
    singleLine={singleLine}
    {...restProps}
  >
    {first && (
      <MessageNotchContainer>
        <Icon type="messageNotch" isCurrentUser={isCurrentUser} />
      </MessageNotchContainer>
    )}
    {children}
  </MessageCard>
);

export default MessageNotch;
